/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-12-05 17:52:11
 * @LastEditors: changfeng
 * @LastEditTime: 2023-01-18 16:30:45
 */
export default {
  'strategy.name': 'Stratgey name',
  'strategy.type': 'Strategy type',

  'strategy.name.placeholder': 'Please enter the strategy name',
  'strategy.effective_time': 'Effctive time',
  'strategy.effective_time.tooltip':
    'The policy takes effect only within the specified period',

  'strategy.effective_account': 'please select an advertise account',
  'strategy.latitude.title': 'Scope',
  'strategy.latitude.campaign': 'Campaign',
  'strategy.latitude.adgroup': 'Adgroup',
  'strategy.latitude.ad': 'Ad',
  'strategy.latitude.errorMessage': 'The effective latitude is required',
  'strategy.latitude.scopeId': 'Scope ID',

  'strategy.scope.title': 'Effective scope',
  'strategy.scope.STATUS_DELIVERY_OK': 'STATUS_DELIVERY_OK',
  'strategy.scope.STATUS_DISABLE': 'STATUS_DISABLE',
  'strategy.scope.STATUS_NOT_DELIVERY': 'STATUS_NOT_DELIVERY',
  'strategy.scope.STATUS_NOT_DELETE': 'STATUS_NOT_DELETE',
  'strategy.scope.errorMessage': 'The effective range is required',

  'strategy.repeat.title': 'Repeated effect',
  'strategy.repeat.always': 'Repeated',
  'strategy.repeat.once': 'Once a day',
  'strategy.repeat.errorMessage': 'Please select weather to repeat',

  'strategy.rule_condition': 'Strategy condition',
  'strategy.action': 'Action',
  'strategy.action.params': 'Action params',

  'strategy.frequency.title': 'Execution frequency',
  'strategy.frequency.placeholder': 'Please Select Execution frequency',
  'strategy.frequency.mins': 'mins',
  'strategy.frequency.hour': 'hour',
  'strategy.frequency.hours': 'hours',

  'strategy.log.startTime': 'startTime',
  'strategy.log.endTime': 'endTime',
};
